import { html } from '@webtides/element-js';
import { ifDefined } from 'lit-html/directives/if-defined';
import FormField from '../form-field/form-field.class';
import style from './select-field.css';

export default class SelectField extends FormField {
    constructor(options) {
        super({ shadowRender: false, styles: [style], ...options });
    }

    properties() {
        return {
            ...super.properties(),
            options: [], // ['string1', 'string2'] or [{value: 'value', label: 'label', selected: true}, ...]
        };
    }

    connected() {
        super.connected();
        // assign proper value after render due to selects nature of value === option[selected].value
        this.value = this.$refs.input.value;
    }

    fieldTemplate() {
        return html`
            <select
                ref="input"
                id="input-${this.name}"
                name="${this.name}"
                ?required="${this.required}"
                ?disabled="${this.disabled}"
                aria-describedby="${this.name}-help"
            >
                ${this.options.map(option => {
                    return html`
                        <option
                            value=${ifDefined(option.value ?? undefined)}
                            ?disabled="${option.disabled}"
                            ?selected=${this.value === option ||
                            this.value === option.value ||
                            (option.selected && !!option.selected)}
                        >
                            ${option.label ?? option}
                        </option>
                    `;
                })}
            </select>
            <div class="icon flex items-center pointer-events-none">
                <svg-icon name="dropdown" class="h-4 w-4"></svg-icon>
            </div>
        `;
    }
}
